import { BaseProxy } from '../base.proxy';
import { Injectable } from '@angular/core';
import { Disclaimer } from '../../model/transferStation/disclaimer.model';

@Injectable()
export class TransferStationProxy extends BaseProxy {
  getDisclaimers() {
    return this._http.get<Disclaimer[]>(
      `/TransferStation/InvestorPortal/GetDisclaimers`
    );
  }

  acceptDisclaimer(code: string) {
    return this._http.get<{ success: boolean }>(
      `/TransferStation/InvestorPortal/AcceptDisclaimer?code=${code}`
    );
  }

  declineDisclaimer(code: string) {
    return this._http.get<{ redirectUrl: string }>(
      `/TransferStation/InvestorPortal/DeclineDisclaimer?code=${code}`
    );
  }
}
